import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import { useMemo } from 'react'
import { useMedia } from './useMedia'

export const useDateMinted = () => {
  const { mintedAt } = useMedia()
  const formattedDate = useMemo(() => `${formatDistanceToNow(new Date(mintedAt))} ago`, [mintedAt])
  return formattedDate
}
